module.exports = __webpack_public_path__ + "static/media/temperature-control-in-place.b71d3a42.svg";